'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _react = _interopRequireWildcard(require("react"));
var _lexical = require("lexical");
var _LexicalComposer = _interopRequireDefault(require("@lexical/react/LexicalComposer"));
var _LexicalComposerContext = require("@lexical/react/LexicalComposerContext");
var _LexicalPlainTextPlugin = _interopRequireDefault(require("@lexical/react/LexicalPlainTextPlugin"));
var _LexicalContentEditable = _interopRequireDefault(require("@lexical/react/LexicalContentEditable"));
var _LexicalOnChangePlugin = _interopRequireDefault(require("@lexical/react/LexicalOnChangePlugin"));
var _LexicalAutoScrollPlugin = _interopRequireDefault(require("@lexical/react/LexicalAutoScrollPlugin"));
var _LexicalAutoFocusPlugin = _interopRequireDefault(require("@lexical/react/LexicalAutoFocusPlugin"));
var _LexicalLinkPlugin = _interopRequireDefault(require("@lexical/react/LexicalLinkPlugin"));
var _LexicalListPlugin = _interopRequireDefault(require("@lexical/react/LexicalListPlugin"));
var _LexicalRichTextPlugin = _interopRequireDefault(require("@lexical/react/LexicalRichTextPlugin"));
var _LexicalTablePlugin = _interopRequireDefault(require("@lexical/react/LexicalTablePlugin"));
var _LexicalHistoryPlugin = require("@lexical/react/LexicalHistoryPlugin");
var _TableActionMenuPlugin = _interopRequireDefault(require("./plugins/TableActionMenuPlugin"));
var _EmojisPlugin = _interopRequireDefault(require("./plugins/EmojisPlugin"));
var _CharacterStylesPopupPlugin = _interopRequireDefault(require("./plugins/CharacterStylesPopupPlugin"));
var _ListMaxIndentLevelPlugin = _interopRequireDefault(require("./plugins/ListMaxIndentLevelPlugin"));
var _EditorTheme = _interopRequireDefault(require("./themes/EditorTheme"));
var _EditorNodes = _interopRequireDefault(require("./nodes/EditorNodes"));
var _ToolbarPlugin = _interopRequireDefault(require("./plugins/ToolbarPlugin"));
var _SharedHistoryContext = require("./context/SharedHistoryContext");
var _Placeholder = _interopRequireDefault(require("./ui/Placeholder"));
var _EditorMsg = _interopRequireDefault(require("./ui/EditorMsg"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
const _excluded = ["onChange", "status"]; // elements plugins
// functions plugins
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
class PureWrapper extends _react.PureComponent {
  render() {
    const props = this.props;
    const output = /*#__PURE__*/_react.default.createElement(EditorWrapper, props);
    return output;
  }
}
exports.default = PureWrapper;
function EditorWrapper(_ref) {
  let {
      onChange,
      status = {}
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const [ticking, setTicking] = (0, _react.useState)(false);
  const [setted_val, setSettedValue] = (0, _react.useState)(null);
  let timeout;
  const initialConfig = {
    namespace: 'c-text-editor',
    nodes: [..._EditorNodes.default],
    onError: error => console.error(error),
    theme: _EditorTheme.default,
    readOnly: props['read-only'] === true
  };
  const status_name = getStatusName();
  let statuses = status[status_name] || {};
  const output = /*#__PURE__*/_react.default.createElement(_LexicalComposer.default, {
    initialConfig: initialConfig
  }, /*#__PURE__*/_react.default.createElement(_LexicalOnChangePlugin.default, {
    onChange: onEditorChange
  }), /*#__PURE__*/_react.default.createElement(_SharedHistoryContext.SharedHistoryContext, null, /*#__PURE__*/_react.default.createElement(Editor, (0, _extends2.default)({}, props, {
    "setted-val": setted_val,
    info: statuses.info,
    error: statuses.error,
    warning: statuses.warning,
    statement: statuses.statement,
    onChange: onEditorChange
  }))));
  return output;
  function onEditorChange(editor_state) {
    if (ticking === true && timeout) {
      window.clearTimeout(timeout);
    }
    const simple_state =
    // keeping selection is not needed
    {
      _nodeMap: (0, _cloneDeep2.default)(editor_state.toJSON()._nodeMap),
      _selection: null
    };
    if (props.uppercase === true) {
      simple_state._nodeMap.forEach(function (map) {
        var _map$;
        if ((_map$ = map[1]) !== null && _map$ !== void 0 && _map$.__text) map[1].__text = map[1].__text.toUpperCase();
      });
    }
    const json = JSON.stringify(simple_state);
    setTicking(true);
    timeout = window.setTimeout(() => {
      timeout = undefined;
      setTicking(false);
      window.requestAnimationFrame(() => emit(json));
    }, 160);
  }
  function emit(string) {
    setSettedValue(string);
    onChange({
      value: string,
      name: props.name
    });
  }
  function getStatusName() {
    var _props$name;
    return !props['error-prefix'] ? props.name : ((_props$name = props.name) === null || _props$name === void 0 ? void 0 : _props$name.includes('[')) === true ? props['error-prefix'] + '[' + props.name.replace('[', '][') : props['error-prefix'] + '[' + props.name + ']';
  }
}
function Editor(props) {
  const {
    historyState
  } = (0, _SharedHistoryContext.useSharedHistoryContext)();
  const [editor] = (0, _LexicalComposerContext.useLexicalComposerContext)();
  const [activeEditor, setActiveEditor] = (0, _react.useState)(editor);
  const text = (props.placeholder || '...').trim();
  const placeholder = props['read-only'] !== true && !(props.value || '').includes('__text') ? /*#__PURE__*/_react.default.createElement(_Placeholder.default, null, "\xA0", text) : undefined;
  const scrollRef = (0, _react.useRef)(null);
  const editor_ref = (0, _react.useRef)(null);
  let handleDocClick;
  (0, _react.useEffect)(() => {
    handleDocClick = function (_ref2) {
      let {
        source,
        data = {}
      } = _ref2;
      if (data.down_was_fired && activeEditor) {
        activeEditor.update(() => {
          (0, _lexical.$setSelection)(null);
        });
      }
    };
    app.push({
      event: 'documentClick',
      cb: handleDocClick
    });
    return () => app.delete({
      event: 'documentClick',
      cb: handleDocClick
    });
  }, []);
  (0, _react.useEffect)(() => {
    return editor.registerCommand(_lexical.SELECTION_CHANGE_COMMAND, (_payload, newEditor) => {
      setActiveEditor(newEditor);
      return false;
    }, _lexical.COMMAND_PRIORITY_EDITOR);
  }, [editor]);

  // set editor state if props value was not set from editor
  (0, _react.useEffect)(() => {
    if (!props.value && !props['setted-val']) return;

    // Set editor value from props
    if (props.value !== props['setted-val']) {
      try {
        editor.setEditorState(editor.parseEditorState(props.value));
      } catch (e) {
        const custom_value = typeof props.value === 'string' && props['text-only'] === true ? props.value.startsWith('__editor-txt:') : false;
        if (!custom_value) {
          console.log(props.value);
          console.error(e);
          return;
        }
        activeEditor.update(() => {
          const paragraphs = props.value.slice('__editor-txt:'.length).split('\n\n').map(function (str) {
            const p = (0, _lexical.$createParagraphNode)();
            str.split('\n').forEach(function (str, i) {
              if (i > 0) {
                const line_break = (0, _lexical.$createLineBreakNode)();
                p.append(line_break);
              }
              const text = (0, _lexical.$createTextNode)(str);
              p.append(text);
            });
            return p;
          });
          const root = (0, _lexical.$getRoot)();
          root.clear();
          paragraphs.forEach(p => root.append(p));
          (0, _lexical.$setSelection)(null);
        });
      }
    }
  }, [props.value]);
  const EditorComponent = props['text-only'] !== true ? _LexicalRichTextPlugin.default : _LexicalPlainTextPlugin.default;
  const modifiers = (props.bemit || []).slice(0);
  if (props['text-only'] === true) modifiers.push('text-only');
  let class_name = (0, _bemit.default)('c-text-editor', modifiers);
  if (props['uppercase'] === true) class_name += ' is-uppercase';
  if (props['read-only'] === true) class_name += ' is-read-only';
  if (props.error) class_name += ' has-error';
  const output = /*#__PURE__*/_react.default.createElement("div", {
    className: class_name + (props.className ? ' ' + props.className : ''),
    ref: editor_ref
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-text-editor__wrapper",
    onMouseDown: captureMouseDown
  }, /*#__PURE__*/_react.default.createElement(_LexicalAutoScrollPlugin.default, {
    scrollRef: scrollRef
  }), props['auto-focus'] ? /*#__PURE__*/_react.default.createElement(_LexicalAutoFocusPlugin.default, null) : undefined, /*#__PURE__*/_react.default.createElement(_LexicalListPlugin.default, null), /*#__PURE__*/_react.default.createElement(_LexicalLinkPlugin.default, null), /*#__PURE__*/_react.default.createElement(_LexicalTablePlugin.default, null), /*#__PURE__*/_react.default.createElement(_TableActionMenuPlugin.default, null), /*#__PURE__*/_react.default.createElement(_EmojisPlugin.default, null), props['disable-floating-formatter'] === true ? undefined : props['text-only'] === true ? undefined : /*#__PURE__*/_react.default.createElement(_CharacterStylesPopupPlugin.default, null), /*#__PURE__*/_react.default.createElement(_ListMaxIndentLevelPlugin.default, {
    maxDepth: 4
  }), /*#__PURE__*/_react.default.createElement(_LexicalHistoryPlugin.HistoryPlugin, {
    externalHistoryState: historyState
  }), /*#__PURE__*/_react.default.createElement(EditorComponent, {
    contentEditable: /*#__PURE__*/_react.default.createElement(_LexicalContentEditable.default, {
      className: "c-text-editor__content-root"
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'c-text-editor__label u-no-select' + (!props.label ? ' is-empty' : ''),
    onClick: focusEditor
  }, props.label || undefined, props['text-only'] === true ? placeholder : undefined), props['text-only'] !== true ? /*#__PURE__*/_react.default.createElement(_ToolbarPlugin.default, {
    "disable-floating-formatter": props['disable-floating-formatter'] === true
  }, props['text-only'] !== true ? placeholder : undefined) : undefined), props.error ? /*#__PURE__*/_react.default.createElement(_EditorMsg.default, {
    message: props.error,
    bemit: ['red']
  }) : undefined);
  return output;
  function captureMouseDown(e) {
    e.persist();
    e.stopPropagation();
    app.emit({
      event: 'documentMouseDown',
      source: 'Editor'
    });
  }
  function focusEditor(e) {
    if (!props.label) return;
    editor.update(() => {
      try {
        (0, _lexical.$getRoot)().selectEnd();
      } catch (e) {
        DOMnativeFocus();
      }
    });
  }
  function DOMnativeFocus() {
    var _editor_ref$current$q;
    if (!(editor_ref !== null && editor_ref !== void 0 && editor_ref.current)) return;
    (_editor_ref$current$q = editor_ref.current.querySelector('.c-text-editor__content-root')) === null || _editor_ref$current$q === void 0 ? void 0 : _editor_ref$current$q.focus();
  }
}
